import { useMutation } from '@apollo/client';
import type {
  InsertTagTypeGroupByNameMutation,
  InsertTagTypeGroupByNameMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertTagTypeGroupByNameDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useInsertTagTypeGroupByNameTRPC } from './useInsertTagTypeGroupByNameTRPC';

export const useInsertTagTypeGroupByName = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [insertTagTypeGroupGraphQL, graphqlState] = useMutation(
    InsertTagTypeGroupByNameDocument
  );

  // tRPC mutation
  const trpcMutation = useInsertTagTypeGroupByNameTRPC();

  const insertTagTypeGroup = async (
    variables: InsertTagTypeGroupByNameMutationVariables
  ): Promise<InsertTagTypeGroupByNameMutation> => {
    if (trpcEnabled) {
      return trpcMutation.insertTagTypeGroup(variables);
    }

    const result = await insertTagTypeGroupGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to insert tag type group');
    }

    return result.data;
  };

  return {
    insertTagTypeGroup,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
